import {
    __,
    filter,
    find,
    flatten,
    groupBy,
    isEmpty,
    length,
    map,
    pipe,
    pluck,
    prop,
    propEq,
    reject,
    sortWith,
    uniq,
    values
} from 'ramda';
import { byRuleDate, byRuleStatus, isCompletedRule } from '../helpers';
import { statuses } from '../constants';

export default ({ games: allGames }) => reducer => (state, action) => {
    const nextState = reducer(state, action);
    const { details } = nextState;

    if (details !== state.details) {
        const { leaderboardRules, gamingContextInfo, status } = details;
        const getAvailableGames = ({ selectedGames = [] } = {}) => filter(prop(__, allGames), selectedGames);

        const getGamesFromCtx = code => pipe(
            prop('gamingContexts'),
            find(propEq('code', code)),
            getAvailableGames
        )(gamingContextInfo);

        const getGames = pipe(
            map(getGamesFromCtx),
            flatten,
            uniq
        );

        const withGames = ({ gameRoundRuleInfo: { gamingContextCodes = [] }, ruleCode, name, ...rest }) =>
            ({ ...rest, games: getGames(gamingContextCodes), id: `${ruleCode}_${name}` });

        const getRulesWithGames = pipe(
            map(withGames),
            reject(({ games }) => isEmpty(games))
        );

        const mergeGames = (rules) => {
            rules[0].games = pipe(
                pluck('games'),
                flatten,
                uniq
            )(rules);

            return rules[0];
        };

        const groupByDates = pipe(
            groupBy(({ startDateTime, endDateTime }) => [startDateTime, endDateTime]),
            values,
            map(rules => rules.length > 1
                ? mergeGames(rules)
                : rules[0])
        );

        const actualRules = pipe(
            filter(rule => !isCompletedRule(rule)),
            sortWith([byRuleStatus, byRuleDate]),
            getRulesWithGames,
            groupByDates
        )(leaderboardRules);

        const getGamesQuantity = pipe(
            pluck('games'),
            flatten,
            uniq,
            length
        );

        return {
            ...nextState,
            details: {
                ...details,
                leaderboardRules: actualRules,
                participatingGames: status === statuses.COMPLETED
                    ? getGamesQuantity(getRulesWithGames(leaderboardRules))
                    : getGamesQuantity(actualRules)
            }
        };
    }

    return nextState;
};
